import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from '@/context/AuthContext';
import { FamilyProvider } from '@/context/FamilyContext';
import { RequireAuth, RequireFamily } from '@/components/ProtectedRoute';
import { Layout } from '@/components/Layout';
import { Login } from '@/pages/Login';
import { CreateFamily } from '@/pages/CreateFamily';
import { Dashboard } from '@/pages/Dashboard';
import { Items } from '@/pages/Items';
import { AddEditItem } from '@/pages/AddEditItem';
import { ItemDetail } from '@/pages/ItemDetail';
import { Family } from '@/pages/Family';
import { Settings } from '@/pages/Settings';

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/create-family"
        element={
          <RequireAuth>
            <CreateFamily />
          </RequireAuth>
        }
      />
      <Route
        path="/"
        element={
          <RequireFamily>
            <Layout>
              <Dashboard />
            </Layout>
          </RequireFamily>
        }
      />
      <Route
        path="/items"
        element={
          <RequireFamily>
            <Layout>
              <Items />
            </Layout>
          </RequireFamily>
        }
      />
      <Route
        path="/items/new"
        element={
          <RequireFamily>
            <AddEditItem />
          </RequireFamily>
        }
      />
      <Route
        path="/items/:id"
        element={
          <RequireFamily>
            <ItemDetail />
          </RequireFamily>
        }
      />
      <Route
        path="/items/:id/edit"
        element={
          <RequireFamily>
            <AddEditItem />
          </RequireFamily>
        }
      />
      <Route
        path="/family"
        element={
          <RequireFamily>
            <Layout>
              <Family />
            </Layout>
          </RequireFamily>
        }
      />
      <Route
        path="/settings"
        element={
          <RequireFamily>
            <Layout>
              <Settings />
            </Layout>
          </RequireFamily>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <FamilyProvider>
          <AppRoutes />
          <Toaster
            position="top-center"
            toastOptions={{
              duration: 3000,
              style: {
                background: '#1f2937',
                color: '#f9fafb',
                borderRadius: '12px',
                fontSize: '14px',
                padding: '12px 16px'
              }
            }}
          />
        </FamilyProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
